export function initiate(token, element, shipZone) {
  // @ts-ignore
  window?.GenCert?.init(element, {
    ship_zone: shipZone,
    token,
  });
  // @ts-ignore
  window?.GenCert?.show();
}
